import { FC } from "react";

import styled from "@emotion/styled";
import Translate from "src/ui/components/Translate/Translate";
import MealHeroBackground from "./MealHeroBackground";
import { Button } from "@9amhealth/shared";

const Card = styled.div`
  position: relative;
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 2rem;
  width: 100%;
  min-height: 464px;
  padding: 1.5rem 1.5rem 2rem;
  border-radius: 0.5rem;
  overflow: hidden;
  background-color: var(--color-cream, #fffcf3);
`;

const Header = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 7px;
  width: 100%;
  text-align: center;
  color: var(--color-charcoal, #212121);
`;

const Title = styled.h2`
  margin: 0;
  font-family: "STK Bureau Serif", serif;
  font-size: 2.25rem;
  font-weight: 300;
  line-height: 2.5rem;
  letter-spacing: -0.54px;
  text-wrap: balance;
`;

const Description = styled.p`
  margin: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: -0.32px;
`;

interface MealInsightsFtuxCardProps {
  onUploadClick: () => void;
  disabled?: boolean;
}

const MealInsightsFtuxCard: FC<MealInsightsFtuxCardProps> = ({
  onUploadClick,
  disabled = false
}) => {
  return (
    <Card>
      <MealHeroBackground />
      <Header>
        <Title>
          <Translate msg="mealInsights.ftux.title" />
        </Title>
        <Description>
          <Translate msg="mealInsights.ftux.description" />
        </Description>
      </Header>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <Button
          onClick={onUploadClick}
          theme="charcoal"
          size="large"
          disabled={disabled}
        >
          <Translate msg="mealInsights.ftux.uploadCta" />
        </Button>
      </div>
    </Card>
  );
};

export default MealInsightsFtuxCard;
